module.exports = __webpack_public_path__ + "static/media/everest_industrial_logo.ea59f0f2.svg";